import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import Noimage from "../../images/3.png";
import { FaShareAlt } from "react-icons/fa";
import { Divider } from "primereact/divider";

import './ViewProduct.css'; // ✅ CSS File Import

function SingleProductCars() {
  const productId = sessionStorage.getItem("productId");

  const [product, setProduct] = useState([]);
  const [productImg, setProductImg] = useState([]);
  const [mainImage, setMainImage] = useState("");

  useEffect(() => {
    if (productId) {
      fetchProductDetails();
      fetchProductImages();
    }
  }, [productId]);

  async function fetchProductDetails() {
    try {
      const res = await fetch(`/allCarsByPID/${productId}`);
      const data = await res.json();
      if (!Array.isArray(data)) throw new Error("Data not in array format");
      setProduct(data);
    } catch (err) {
      console.error("Product fetch error:", err.message);
    }
  }

  async function fetchProductImages() {
    try {
      const res = await fetch(`/allProductsMediaByPID/${productId}`);
      const data = await res.json();
      if (!Array.isArray(data)) throw new Error("Media not in array format");
      setProductImg(data);
      if (data.length > 0) {
        setMainImage(`data:image/png;base64,${data[0].productImages}`);
      }
    } catch (err) {
      console.error("Image fetch error:", err.message);
    }
  }

  const handleThumbnailClick = (img) => {
    setMainImage(`data:image/png;base64,${img.productImages}`);
  };

  function handleShare(product) {
    const shareText = `Check out this product: ${product.productName}, Price: ₹${product.price}`;
    const shareUrl = `${window.location.origin}/product/${product.productID}`;

    if (navigator.share) {
      navigator
        .share({
          title: product.productName,
          text: shareText,
          url: shareUrl,
        })
        .then(() => console.log("Product shared successfully"))
        .catch((error) => console.error("Error sharing", error));
    } else {
      navigator.clipboard.writeText(shareUrl).then(() => {
        alert("Product link copied to clipboard. Share it anywhere!");
      });
    }
  }

  const renderSpec = (label, value) => {
    if (!value) return null;
    return (
      <div className="spec-row">
        <strong className="spec-label">{label}:</strong>
        <span>{value}</span>
      </div>
    );
  };

  return (
    <>
      <div className="product-container">
        {/* Thumbnail Column */}
        <div className="thumbnail-column">
          {productImg.map((img, idx) => (
            <img
              key={idx}
              src={
                img.productImages
                  ? `data:image/png;base64,${img.productImages}`
                  : Noimage
              }
              alt="Thumbnail"
              onClick={() => handleThumbnailClick(img)}
              className={`thumbnail-image ${
                mainImage.includes(img.productImages) ? "active-thumbnail" : ""
              }`}
            />
          ))}
        </div>

        {/* Main Image */}
        <div className="main-image-container">
          <img
            src={mainImage || Noimage}
            alt="Main Product"
            className="main-image"
          />
        </div>

        {/* Product Details */}
        <div className="product-details">
          {product.map((prdct) => (
            <div key={prdct.productID}>
              <h2 className="product-title">{prdct.productName}</h2>
              <p>
                <strong className="text-gray">Price:</strong>{" "}
                <span className="text-red">₹{prdct.price}</span>
              </p>
              <p>
                <strong>Color:</strong> {prdct.color}
              </p>
              <p>
                <strong>Age Group:</strong> {prdct.ageGroup}
              </p>
              <p>
                <strong>Brand:</strong> {prdct.brand}
              </p>

              <a
                href={`https://wa.me/919490384177?text=Hi, I'm interested in buying the product: ${encodeURIComponent(
                  prdct.productName
                )}, Price: ₹${prdct.price}`}
                target="_blank"
                rel="noopener noreferrer"
                className="whatsapp-button"
              >
                Shop on WhatsApp
              </a>

              <button
                onClick={() => handleShare(prdct)}
                className="share-button"
                title="Share Product"
              >
                <FaShareAlt />
              </button>
            </div>
          ))}
        </div>
      </div>

      <Divider />

      <div className="spec-container">
        {product.map((prdct) => (
          <div key={`desc-spec-${prdct.productID}`}>
            <h4 className="section-title">Specifications</h4>

            <h5 className="section-subtitle">General</h5>
            <div className="spec-grid">
              {renderSpec("Type", prdct.type)}
              {renderSpec("Model Number", prdct.modelNumber)}
              {renderSpec("Color", prdct.color)}
              {renderSpec("Speed", prdct.speed)}
              {renderSpec("Weight", prdct.weight)}
              {renderSpec("Country of Origin", prdct.countryOfOrigin)}
              {renderSpec("Manufacturer", prdct.manufacturer)}
            </div>

            <h5 className="section-subtitle">Power Features</h5>
            <div className="spec-grid">
              {renderSpec("Battery Type", prdct.batteryType)}
              {renderSpec(
                "Battery Included",
                prdct.batteryIncluded ? "Yes" : "No"
              )}
              {renderSpec("Rechargeable", prdct.rechargeable ? "Yes" : "No")}
            </div>

            <h5 className="section-subtitle">Convenience Features</h5>
            <div className="spec-grid">
              {renderSpec(
                "Parental Remote",
                prdct.parentalRemote ? "Yes" : "No"
              )}
              {renderSpec(
                "MP3 Player Supported",
                prdct.mpThreePlayerSupported ? "Yes" : "No"
              )}
              {renderSpec(
                "Other Convenience Features",
                prdct.otherConvenienceFeatures
              )}
            </div>

            <h5 className="section-subtitle">Dimensions</h5>
            <div className="spec-grid">
              {renderSpec("Dimensions", prdct.dimentions)}
              {renderSpec("Maximum User Weight", prdct.maximumUserWeight)}
            </div>

            <h5 className="section-subtitle">Warranty</h5>
            <div className="spec-grid">
              {renderSpec("Warranty", prdct.warrenty)}
              {renderSpec("Covered in Warranty", prdct.coveredInWarranty)}
              {renderSpec(
                "Not Covered in Warranty",
                prdct.notCoveredInWarranty
              )}
            </div>
          </div>
        ))}
      </div>
    </>
  );
}

export default SingleProductCars;
